import imageCompression from 'browser-image-compression';

interface CompressionOptions {
	quality?: number; // 0-1, default 0.95
	maxWidthOrHeight?: number; // Max dimension in pixels
}

export class ImageCompression {
	/**
	 * Compress an image file using browser-image-compression library
	 * Preserves EXIF metadata
	 */
	static async compressImage(file: File, options: CompressionOptions = {}): Promise<Uint8Array<ArrayBuffer>> {
		const compressionOptions = {
			maxSizeMB: 10, // Max file size in MB
			maxWidthOrHeight: options.maxWidthOrHeight ?? 4096, // Limit dimensions to 4096px
			useWebWorker: false,
			preserveExif: true,
			initialQuality: options.quality ?? 0.95,
		};

		const compressedFile = await imageCompression(file, compressionOptions);

		// Convert File to Uint8Array for upload
		const arrayBuffer = await compressedFile.arrayBuffer();
		return new Uint8Array(arrayBuffer);
	}
}
